<!-- Query string 測試頁：/query_test -->
<template>
  <div class="layout_wrapper">
    <h5>query string page</h5>

    <p
      v-for="(str, idx) in Object.keys(queryStr)"
      :key="idx"
      class="query_para"
    >
      {{ `${str}: ${queryStr[str]}` }}
    </p>
  </div>
</template>

<script>
import { ref } from 'vue';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'QueryTest',
  components: {
  },
  setup () {
    const { currentRoute } = useCommon();

    const queryStr = ref(currentRoute.query);

    return {
      queryStr
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';

h5 {
  @include font-size-bold-18;

  margin: 20px 0px;
  text-align: center;
}

.query_para {
  text-align: center;
}
</style>
